import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { useCollectionUrlGenerator } from '../../hooks/useUrlGenerator';

import Summary, { SummaryProps } from './Summary';

import styles from '../../styles/summaries/collection-summary.module.css';

interface CollectionSummaryProps extends SummaryProps {
    type?: string | null;
    slug?: string | null;
    title?: string | null;
    image?: Image | null;
    metadata?: CollectionMetadata | null;
    className?: string | null;
    imageClassName?: string | null;
    pictureClassName?: string | null;
    descriptionClassName?: string | null;
}

function CollectionSummary({
    type = null,
    slug = null,
    title = null,
    image = null,
    metadata = null,
    className = null,
    imageClassName = null,
    pictureClassName = null,
    descriptionClassName = null,
    ...props
}: CollectionSummaryProps) {
    const { sponsors = null } = metadata || {};
    const [sponsor = null] = sponsors || [];
    const collectionUrl = useCollectionUrlGenerator();
    return (
        <Summary
            link={
                collectionUrl({
                    type,
                    slug,
                }) || '#'
            }
            title={title}
            sponsor={sponsor}
            image={image}
            className={classNames([styles.container, className])}
            imageClassName={classNames([styles.image, imageClassName])}
            descriptionClassName={classNames([styles.description, descriptionClassName])}
            pictureClassName={classNames([styles.picture, pictureClassName])}
            buttonLabel={<FormattedMessage defaultMessage="Voir plus" description="Button label" />}
            {...props}
        />
    );
}

export default CollectionSummary;
